import { apiClient } from '@/api/api'
import type { AxiosResponse } from 'axios'

export interface AuthCredentials {
  email: string
  password: string
}

export interface SignUpPayload {
  name: string
  email: string
  password: string
}

export interface ResetPasswordPayload {
  token: string
  password: string
}

export interface ThirdPartyAuthResponse {
  auth_uri: string
}

export interface TokensResponse {
  access_token: string
  expires_in: number
  // Absent when Cognito refresh-token rotation is off: REFRESH_TOKEN_AUTH
  // then returns no new refresh token and the API omits both fields.
  refresh_token?: string
  refresh_expires_in?: number
}

export interface RefreshTokensPayload {
  username: string
  refresh_token: string
}

export const login = (payload: AuthCredentials) => {
  return apiClient.post('/auth/login', payload)
}

export const signUp = (payload: SignUpPayload) => {
  return apiClient.post('/auth/signup', payload)
}

export const thirdPartyLogin = (provider: string) => {
  return apiClient.get<ThirdPartyAuthResponse>(`/auth/login-with-third-party/${provider}`)
}

export const exchangeCodeForTokens = (code: string) => {
  return apiClient.get(`/auth/exchange-code-for-tokens/?code=${code}`)
}

export const verifyEmail = (token: string) => {
  return apiClient.get(`/auth/verify-email?token=${token}`)
}

export const resetPassword = (payload: ResetPasswordPayload) => {
  return apiClient.post(`/auth/reset-password`, payload)
}

export const refreshTokens = (payload: RefreshTokensPayload) => {
  return apiClient.post<TokensResponse>('auth/refresh_tokens', payload)
}

export const logout = async (): Promise<AxiosResponse<void>> => {
  // Placeholder for future backend call
  return Promise.resolve({} as AxiosResponse<void>)
}

